import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from '../../utils/classNames';
import styles from './TextChip.module.css';
const handleDelete = (e, onDelete, itemId) => {
    e.stopPropagation();
    if (onDelete) {
        onDelete(e, itemId);
    }
};
const handleClick = (e, onClick) => {
    e.stopPropagation();
    if (onClick) {
        onClick(e);
    }
};
const TextChip = ({ label, className, variant, onClick = null, onDelete = null, itemId, }) => (_jsxs("div", Object.assign({ className: cx(styles.container, variant === 'light' ? styles.lightContainer : '', className), onClick: (e) => handleClick(e, onClick) }, { children: [label, onDelete ? (_jsx("button", Object.assign({ type: "button", className: cx(styles.deleteButton, variant === 'light' ? styles.lightDeleteButton : ''), onClick: (e) => handleDelete(e, onDelete, itemId) }, { children: "\u00D7" }), void 0)) : null] }), void 0));
export default TextChip;
